import styles from './RadioField.module.scss';
import { SFRadio, SFStateMandatedLabel } from 'sfui';
import { InputProps } from '../FieldInput';
import React from 'react';

export interface RadioFieldProps extends InputProps {
  className?: string;
}

export const RadioField = (
  props: RadioFieldProps
): React.ReactElement<RadioFieldProps> => {
  return (
    <div className={`${styles.radioInput} ${props.className ?? ''}`}>
      {props.label && (
        <div className={styles.fieldLabel}>
          {props.showStateMandated && (
            <SFStateMandatedLabel
              label={props.label}
              required={props.required}
            />
          )}
          {!props.showStateMandated && (
            <span>{`${props.label}${props.required ? ' *' : ''}`}</span>
          )}
        </div>
      )}

      <div
        className={`${styles.options} ${!props.label ? styles.noLabel : ''}`}
      >
        {props.options?.map((option: string) => (
          <SFRadio
            key={option}
            label={option}
            checked={props.value === option}
            onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked) =>
              checked && props.onChange(option)
            }
          />
        ))}
      </div>
    </div>
  );
};
